module.exports = __webpack_public_path__ + "img/bird-6-left.5bc410a8.png";